<template>
  <div>
        <MasterHeader
        v-bind:classHeader="'registration'"
        v-bind:classGrid="'wp1200'"
        v-bind:showToastError="showToastError"
        v-bind:showToastMessage="showToastMessage"/>
    <section>
      <div class="wp800">
        <div class="onBoardRegistration verification">
         <div class="content">
           <div class="col1_2">
             <img src="@/assets/images/mailOnWay.svg" class="mainImage" />
           </div>

           <div class="col1_2 text ">
            <span class="check">
              <strong>{{ $t("login.check_your_email") }}</strong>
            </span>
            <span class="normal">{{ $t("login.verification_email_sent") }}</span>
             <form class="custom-form" 
              v-on:submit.prevent="onSubmit"
             >
               <div class="form-group" v-bind:class="{ 'not-empty': !isVerificationCodeEmpty }">
                 <input
                     type="text"
                     class="form-control"
                     name="code"
                     id="code"
                     v-model="form.verificationCode"
                     @blur="formUtilsCheckVerificationCodeEmpty()"
                 />
                 <label for="code" class="animated-label">{{ $t("login.verification_code") }}</label>
                 <span class="line"></span>
               </div>
             </form>

           </div>
         </div>
          <div class="actionButtons">
            <a
                class="join smallFont hoverEffect"
                ref="joinButton1"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:click.prevent="onSubmit()"
                href="javascript:void(0);"
            >
              <label>{{ $t("login.next_step") }}</label>
              <span
                  class="effect"
                  ref="effectButton1"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
              ></span>
              <img src="@/assets/images/nextArrowAnimation.svg" />
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterHeader from '../partials/MasterHeader';
import { formUtilsCheckVerificationCodeEmpty, formUtilsMouseHoverEffect } from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastMessage: "",
      password: "",
      form: {
        email: "",
        verificationCode: "",
        recaptchaToken: "",
      },
      isVerificationCodeEmpty: true,
      tokenValid: false,
      topX: 1,
      leftX: 1 // ,
      // recaptchaSiteKey: window.VUE_APP_RECAPTCHA_KEY,
    };
  },
  computed:{
    user() {
      return this.$store.getters['user/user'];
    }
  },
  components: {
    MasterHeader
  },
  mounted() {
    this.$initRecaptcha();

    console.log('mounted START');
    this.$store.dispatch("app/loader", false);
    this.form.email = this.$cookie.get('verification_email');

    const verificationValid = this.$cookie.get('verification_accept');
    if (!this.form.email || verificationValid !== 'true') {
      this.$router.push({
        name: "login",
      });
    }
    console.log('mounted END');
  },
  methods: {
    formUtilsCheckVerificationCodeEmpty,
    formUtilsMouseHoverEffect,

    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      if (this.form.verificationCode.length < 6) {
        this.showToastMessage = this.$t("error.invalid_verification_code");
        this.showToastError = true;
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },


    sendForm(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;
      this.$http
        .post("api/v1/validateVerificationCode", this.form)
        .then(() => {
          this.$cookie.delete('verification_email');
          this.$cookie.delete('verification_accept');
          this.$router.push({
            name: "login",
            query:{
              activeTab: 'login',
              verified:true
            }
          });
        })

        .catch((error) => {
          if (error.status == "400") {
            this.showToastMessage = "Prosimo preverite in ponovno vpišite vaše verifikacijsko geslo";
            this.showToastError = true;
            return;
          }
          if (error.status == "422") {
            this.showToastMessage = "Podatki so bili neveljavni";
            this.showToastError = true;
            return;
          }
        });
    },


  },
};
</script>
<style>
</style>